import React from "react";

const STYLES = {
  success: { bg: "rgba(34,197,94,0.10)", fg: "#22C55E", border: "rgba(34,197,94,0.25)" },
  warning: { bg: "rgba(245,158,11,0.10)", fg: "#F59E0B", border: "rgba(245,158,11,0.25)" },
  critical: { bg: "rgba(239,68,68,0.10)", fg: "#EF4444", border: "rgba(239,68,68,0.30)" },
  info: { bg: "rgba(91,141,239,0.12)", fg: "#5B8DEF", border: "rgba(91,141,239,0.30)" },
  neutral: { bg: "rgba(255,255,255,0.04)", fg: "#94A3B8", border: "rgba(255,255,255,0.08)" },
};

export default function StatusPill({ tone = "neutral", children, dot = true, className = "", "data-testid": testId }) {
  const s = STYLES[tone] || STYLES.neutral;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium ${className}`}
      style={{ backgroundColor: s.bg, color: s.fg, borderColor: s.border }}
    >
      {dot && (
        <span
          className="inline-block h-1.5 w-1.5 rounded-full"
          style={{ backgroundColor: s.fg, boxShadow: `0 0 8px ${s.fg}` }}
        />
      )}
      {children}
    </span>
  );
}
